module.exports = __webpack_public_path__ + "img/lightPackage.b69367de.svg";